import { createClient } from "@sanity/client";

let sanityClient = null;

export function hasSanityConfig() {
  return Boolean(
    process.env.REACT_APP_SANITY_PROJECT_ID &&
      process.env.REACT_APP_SANITY_DATASET &&
      process.env.REACT_APP_SANITY_API_VERSION
  );
}

export function getSanityClient() {
  if (!hasSanityConfig()) {
    return null;
  }

  if (!sanityClient) {
    const token = process.env.REACT_APP_SANITY_API_TOKEN;
    sanityClient = createClient({
      projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
      dataset: process.env.REACT_APP_SANITY_DATASET,
      apiVersion: process.env.REACT_APP_SANITY_API_VERSION,
      useCdn: !token,
      token: token || undefined,
      perspective: token ? "previewDrafts" : "published",
    });
  }

  return sanityClient;
}
